import { render, staticRenderFns } from "./EditBool.vue?vue&type=template&id=e81eb4da&"
import script from "./EditBool.vue?vue&type=script&lang=js&"
export * from "./EditBool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports